import React, { useRef, useState, useEffect } from "react"
import Tooltip from "@material-ui/core/Tooltip"
import { Chip } from "@material-ui/core"
import styled from "styled-components"

export const StyledChip = styled(Chip)`
  max-width: 250px;
  min-width: auto;
  height: 30px;
  margin: 4px;
  border-radius: 16px;
  background-color: #EEF2FF !important;

  .MuiChip-label {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
    max-width: 250px;
    min-width: auto;
    display: block;
  }
`

function EllipsisChipWithTooltip ({ item }) {

  const labelRef = useRef(null)
  const [showTooltip, setShowTooltip] = useState(false)

  useEffect(() => {
    const el = labelRef.current
    if (el) {
      setShowTooltip(el.scrollWidth > el.clientWidth)
    }
  }, [item.title])

  const chip = (
    <StyledChip
      key={item.id}
      label={
        <span
          ref={labelRef}
          style={{
            display: "inline-block",
            maxWidth: "220px",
            overflow: "hidden",
            textOverflow: "ellipsis",
            whiteSpace: "nowrap",
            verticalAlign: "middle",
          }}
        >
          {item.title}
        </span>
      }
    />
  )

  return showTooltip ? (
    <Tooltip title={item.title} arrow>
      <span>{chip}</span>
    </Tooltip>
  ) : (
    chip
  )
}

export { EllipsisChipWithTooltip }
export default EllipsisChipWithTooltip